















































import {
	defineComponent,
	onMounted,
	Ref,
	ref,
} from '@vue/composition-api';
import PlusButton from '@front-app/components/buttons/PlusButton.vue';
import ColumnContainer from '@front-app/components/layouts/columns/ColumnContainer.vue';
import { getAllCommunities } from '@front-app/services/CommunityApi/CommunityApi';
import { Community, CommunityWithGroups } from '@front-app/services/CommunityApi/CommunityModel';
import { Spacing } from '@front-app/components/constants';
import { useAsyncStatus } from '@front-app/hooks/useAsyncStatus';
import ScrollingColumn from '@front-app/components/layouts/columns/ScrollingColumn.vue';
import LoaderState from '@front-app/components/LoaderState.vue';
import CreateCommunityModal from '@front-app/modules/community/CreateCommunityModal.vue';
import ColumnHeader from '@front-app/components/layouts/columns/ColumnHeader.vue';
import CommunityCard from '@front-app/modules/community/CommunityCard.vue';
import ErrorCard from '@front-app/components/cards/state/ErrorCard.vue';

export default defineComponent({
	components: {
		ColumnContainer,
		PlusButton,
		ScrollingColumn,
		LoaderState,
		CreateCommunityModal,
		ColumnHeader,
		CommunityCard,
		ErrorCard,
	},
	setup() {
		const {
			isLoading: isLoadingPage,
			isError: isErroredPage,
			track,
		} = useAsyncStatus();
		const communities: Ref<Community[]> = ref([]);
		onMounted(async () => {
			communities.value = await track(getAllCommunities());
		});
		const createCommunityModalIsOpen = ref(false);
		const addCreatedCommunity = (creation: CommunityWithGroups) => {
			communities.value = [creation, ...communities.value];
		};
		const removeCommunityFromList = async (deletedId: string) => {
			communities.value = communities.value.filter(({ id }) => id !== deletedId);
		};

		return {
			communities,
			addCreatedCommunity,
			removeCommunityFromList,
			createCommunityModalIsOpen,
			// Initial page load
			isLoadingPage,
			isErroredPage,
			// Util
			Spacing,
		};
	},
});
